import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "../assets/css/bootstrap.min.css";
import "../assets/css/font-awesome.min.css";
import "../assets/css/fontawesome-stars-o.min.css";
import "../assets/css/responsive-style.css";
import "../assets/css/colors/theme-color-1.css";
import "../assets/css/custom.css";
import "../assets/css/home.css";
import Loader from "../components/Loader";
import CategoryWidget from "../components/CategoryWidget";

const BlogList = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get("http://localhost:5000/api/blogs/");
        setBlogs(response.data);
      } catch (error) {
        console.error("Error fetching blogs:", error);
      }
      setLoading(false);
    };
    fetchBlogs();
  }, []);

  if (loading) return <Loader />;
  if (blogs.length === 0) return <p>No blogs available.</p>;
  return (
    <div>
      {/* Posts Filter Bar Start */}
      <div className="posts--filter-bar style--1 hidden-xs">
        <div className="container">
          <ul className="nav">
            <li>
              <a href="#">
                <i className="fa fa-star-o" />
                <span>Featured News</span>
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fa fa-heart-o" />
                <span>Most Popular</span>
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fa fa-fire" />
                <span>Hot News</span>
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fa fa-flash" />
                <span>Trending News</span>
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fa fa-eye" />
                <span>Most Watched</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      {/* Posts Filter Bar End */}
      {/* News Ticker Start */}

      {/* News Ticker End */}
      {/* Main Breadcrumb Start */}
      <div className="main--breadcrumb">
        <div className="container">
          <ul className="breadcrumb">
            <li>
              <a href="home-1.html" className="btn-link">
                <i className="fa fm fa-home" />
                Home
              </a>
            </li>
            <li className="active">
              <span>Blog</span>
            </li>
          </ul>
        </div>
      </div>
      {/* Main Breadcrumb End */}

      {/* Main Content Section Start */}
      <div className="main-content--section pbottom--30">
        <div className="container">
          <div className="row">
            {/* Main Content Start */}
            <div
              className="main--content col-md-8 col-sm-7"
              data-sticky-content="true"
            >
              <div className="sticky-content-inner">
                {/* Post Items Start */}

                {/*api data start */}
                {/* API Data Start */}
                <div className="post--items post--items-2 pd--30-0">
                  <ul className="nav row AdjustRow">
                    <h1><strong>Recent Blogs</strong></h1>
                    {blogs.map((blog) => (
                      <li
                        key={blog.id}
                        className="col-md-6 col-sm-12 col-xs-6 col-xss-12"
                        style={{ width: "400px", height: "550px" }}
                      >
                        {" "}
                        {/* Set fixed size */}
                        <hr style={{ width: "400px", margin: "20px auto" }} />
                        <div className="post--item post--layout-1 post--title-large">
                          <div
                            className="post--img"
                            style={{ position: "relative" }}
                          >
                            {" "}
                            {/* Add position relative to the image box */}
                            <Link to={`/blogs/${blog.id}`} className="thumb">
                              <img
                                src={
                                  blog.image && blog.image.trim()
                                    ? blog.image
                                    : "/img/blog-img/default.jpg"
                                }
                                alt={blog.title || "Default Blog Image"}
                                onError={(e) => {
                                  e.target.src = "img/ads-img/ad-300x250-2.jpg";
                                }} // Handle broken images
                                style={{
                                  width: "270px",
                                  height: "180px",
                                  objectFit: "cover",
                                  display: "block",
                                  margin: "auto",
                                }} // Center image
                              />
                            </Link>
                            <div
                              className="post--info"
                              style={{
                                position: "absolute",
                                bottom: "-20px",
                                left: "-10px",
                                color: "white",
                                padding: "5px",
                                borderRadius: "5px",
                              }}
                            >
                              <ul className="nav meta">
                                <li>
                                  <a href="#" style={{ color: "white" }}>
                                    {blog.author}
                                  </a>
                                </li>
                                <li>
                                  <a href="#" style={{ color: "white" }}>
                                    {blog.publishDate}
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <Link to="#" className="cat">
                              {blog.category}
                            </Link>
                          </div>
                          <div className="title">
                            <h3 style={{ textAlign: "left" }}>
                              <Link
                                to={`/blogs/${blog.id}`}
                                className="btn-link"
                              >
                                <strong>{blog.title}</strong>
                              </Link>{" "}
                              {/* Make text bold */}
                            </h3>
                          </div>
                          <div className="post--content">
                            <p>{blog.shortDescription.slice(0, 200)}...</p>
                          </div>
                          <div className="post--action">
                            <Link to={`/blogs/${blog.id}`}>
                              Continue Reading...
                            </Link>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* api data end   */}
              </div>
            </div>
            {/* Main Content End */}
            {/* Main Sidebar Start */}
            <div
              className="main--sidebar col-md-4 col-sm-5 ptop--30 pbottom--30"
              data-sticky-content="true"
            >
              <div className="sticky-content-inner">
                {/* Widget Start */}
                <div className="widget">
                  {/* Search Widget Start */}
                  <div className="search--widget">
                    <form action="#" data-form="validate">
                      <div className="input-group">
                        <input
                          type="search"
                          name="search"
                          placeholder="Search..."
                          className="form-control"
                          required
                        />
                        <div className="input-group-btn">
                          <button type="submit" className="btn-link">
                            <i className="fa fa-search" />
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                  {/* Search Widget End */}
                </div>
                {/* Widget End */}

                {/* Widget Start */}
                <div>
                  {" "}
                  <CategoryWidget />{" "}
                </div>
                {/* Widget End */}

                {/* Widget Start */}
                <div className="widget">
                  <div className="widget--title">
                    <h2 className="h4">Tags</h2>
                    <i className="icon fa fa-tags" />
                  </div>
                  {/* Tags Widget Start */}
                  <div className="tags--widget style--1">
                    <ul className="nav">
                      <li>
                        <a href="#">News</a>
                      </li>
                      <li>
                        <a href="#">Image</a>
                      </li>
                      <li>
                        <a href="#">Music</a>
                      </li>
                      <li>
                        <a href="#">Video</a>
                      </li>
                      <li>
                        <a href="#">Audio</a>
                      </li>
                      <li>
                        <a href="#">Fashion</a>
                      </li>
                      <li>
                        <a href="#">Latest</a>
                      </li>
                      <li>
                        <a href="#">Trendy</a>
                      </li>
                      <li>
                        <a href="#">Special</a>
                      </li>
                      <li>
                        <a href="#">Recipe</a>
                      </li>
                      <li>
                        <a href="#">Sports</a>
                      </li>
                    </ul>
                  </div>
                  {/* Tags Widget End */}
                </div>
                {/* Widget End */}
                {/* Widget Start */}
                <div className="widget">
                  <div className="widget--title">
                    <h2 className="h4">Archives</h2>
                    <i className="icon fa fa-folder-open-o" />
                  </div>
                  {/* Nav Widget Start */}
                  <div className="nav--widget">
                    <ul className="nav">
                      <li>
                        <a href="#">
                          <span>March 2017</span>
                          <span>(22)</span>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <span>April 2017</span>
                          <span>(16)</span>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <span>May 2017</span>
                          <span>(84)</span>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <span>January 2016</span>
                          <span>(11)</span>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <span>February 2016</span>
                          <span>(19)</span>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <span>March 2016</span>
                          <span>(36)</span>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <span>April 2016</span>
                          <span>(41)</span>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <span>October 2015</span>
                          <span>(39)</span>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <span>Nover 2015</span>
                          <span>(15)</span>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <span>Decemberr 2015</span>
                          <span>(28)</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                  {/* Nav Widget End */}
                </div>
                {/* Widget End */}
                {/* Widget Start */}

                <div className="widget">
                  {/* List Widgets Start */}
                  <div className="list--widget list--widget-1">
                    {/* Post Items Start */}
                    <div
                      className="post--items post--items-3"
                      data-ajax-content="outer"
                    >
                      <ul className="nav" data-ajax-content="inner">
                        <li>
                          {/* Post Item Start */}
                          <div className="post--item post--layout-3">
                            <div className="post--img">
                              <a href="#" className="thumb">
                                <img
                                  src="img/widgets-img/news-widget-02.jpg"
                                  alt
                                />
                              </a>
                              <div className="post--info">
                                <ul className="nav meta">
                                  <li>
                                    <a href="#">Orcus</a>
                                  </li>
                                  <li>
                                    <a href="#">16 April 2017</a>
                                  </li>
                                </ul>
                                <div className="title">
                                  <h3 className="h4">
                                    <a href="#" className="btn-link">
                                      Long established fact that a reader will
                                      be distracted
                                    </a>
                                  </h3>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* Post Item End */}
                        </li>
                        <li>
                          {/* Post Item Start */}
                          <div className="post--item post--layout-3">
                            <div className="post--img">
                              <a href="#" className="thumb">
                                <img
                                  src="img/widgets-img/news-widget-03.jpg"
                                  alt
                                />
                              </a>
                              <div className="post--info">
                                <ul className="nav meta">
                                  <li>
                                    <a href="#">Rahab</a>
                                  </li>
                                  <li>
                                    <a href="#">16 April 2017</a>
                                  </li>
                                </ul>
                                <div className="title">
                                  <h3 className="h4">
                                    <a href="#" className="btn-link">
                                      Long established fact that a reader will
                                      be distracted
                                    </a>
                                  </h3>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* Post Item End */}
                        </li>
                        <li>
                          {/* Post Item Start */}
                          <div className="post--item post--layout-3">
                            <div className="post--img">
                              <a href="#" className="thumb">
                                <img
                                  src="img/widgets-img/news-widget-04.jpg"
                                  alt
                                />
                              </a>
                              <div className="post--info">
                                <ul className="nav meta">
                                  <li>
                                    <a href="#">Tannin</a>
                                  </li>
                                  <li>
                                    <a href="#">16 April 2017</a>
                                  </li>
                                </ul>
                                <div className="title">
                                  <h3 className="h4">
                                    <a href="#" className="btn-link">
                                      Long established fact that a reader will
                                      be distracted
                                    </a>
                                  </h3>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* Post Item End */}
                        </li>
                      </ul>
                      {/* Preloader Start */}
                      <div
                        className="preloader bg--color-0--b"
                        data-preloader={1}
                      >
                        <div className="preloader--inner" />
                      </div>
                      {/* Preloader End */}
                    </div>
                    {/* Post Items End */}
                  </div>
                  {/* List Widgets End */}
                </div>
                {/* Widget End */}
                {/* Widget Start */}

                {/* Widget End */}
                {/* Widget Start */}

                {/* Widget End */}
              </div>
            </div>
            {/* Main Sidebar End */}
          </div>
        </div>
      </div>
      {/* Main Content Section End */}
      <div id="backToTop">
        <a href="#">
          <i className="fa fa-angle-double-up"></i>
        </a>
      </div>
    </div>
  );
};

export default BlogList;
